export const formatRelativeDate = (inputDate: string) => {
  const todayDate = new Date()
  const currentDate = new Date(parseInt(inputDate, 10)) // Указываем основание 10

  // Убираем время и миллисекунды из сегодняшней и предыдущей дат
  todayDate.setHours(0, 0, 0, 0)
  const prevDay = new Date(todayDate)
  prevDay.setDate(todayDate.getDate() - 1)

  // Убираем время и миллисекунды из входной даты
  currentDate.setHours(0, 0, 0, 0)

  if (todayDate.getTime() === currentDate.getTime()) {
    return "Сегодня"
  }
  if (prevDay.getTime() === currentDate.getTime()) {
    return "Вчера"
  }

  return currentDate.toLocaleDateString("ru-RU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}
